import User from "./User";
import { useState } from "react";
import CustomerDropDownSelector from "../controls/CustomerDropDownSelector";
import AgreementDropDownSelector from "../controls/AgreementDropDownSelector";

const Users = ({
  users,
  saveData,
  deleteData,
  customers,
  agreements,
  setSelectedCustomer,
  getInstance,
}) => {
  const [customerId, setCustomerId] = useState("NA");
  const [agreementId, setAgreementId] = useState("NA");
  let oldUser = "";

  return (
    <div className="divUsers">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: 30,
        }}
      >
        <div>
          <CustomerDropDownSelector
            headerText="Kund"
            ddData={customers}
            customerId={customerId}
            setCustomerId={(id) => {
              setCustomerId(id);
              setSelectedCustomer(id);
              setAgreementId("NA");
            }}
          />
        </div>
        <div>
          <AgreementDropDownSelector
            headerText="Avtal"
            agreements={agreements}
            agreementId={agreementId}
            setAgreementId={setAgreementId}
          />
        </div>
      </div>
      {users.length > 0 ? (
        users.map((user, index) =>
          (customerId === "NA" || user.CustomerNo === customerId) &&
          (agreementId === "NA" || user.Agreements === agreementId) ? (
            <>
              <User
                key={index}
                user={user}
                sameAsBefore={user.UserName === oldUser}
                saveData={saveData}
                deleteData={deleteData}
                customers={customers}
                getInstance={getInstance}
              />
              <div className="divHide">{(oldUser = user.UserName)}</div>
            </>
          ) : (
            <></>
          )
        )
      ) : (
        <>Användare saknas</>
      )}
    </div>
  );
};

export default Users;
